<section class="multicheck">
     <label class="multicheck__wrap" *ngFor="let item of eventsList">
        <input class="multicheck__checkbox" type="checkbox" 
        [checked]="item.checked" (change)="onEventChange(item, $event)">
         <span>{{item.titleVenue + ' - ' + item.eventDate}}</span>
    </label>
</section>